export default {
  comments: [],
  solutionComments: [],
  comment: undefined,
};
